module.exports = __webpack_public_path__ + "assets/img/free_8.23284e1d.png";